import React from 'react'
import { Switch, SwitchProps, FormControlLabel } from '@mui/material'
import { styled } from '@mui/material/styles'
import { switchClasses } from '@mui/material/Switch'
import TealToolTip from 'components/TealToolTip'

const StyledSwitch = styled(Switch)({
  width: 32,
  height: 18,
  padding: 0,
  display: 'flex',
  [`& .${switchClasses.switchBase}`]: {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(14px)',
      color: '#fff',
      [`& + .${switchClasses.track}`]: {
        backgroundColor: '#4caf50',
        opacity: 1,
        border: 'none'
      }
    }
  },
  [`& .${switchClasses.thumb}`]: {
    width: 14,
    height: 14
  },
  [`& .${switchClasses.track}`]: {
    borderRadius: 9,
    backgroundColor: '#bdbdbd',
    opacity: 1,
    transition: 'background-color 0.2s'
  }
})

type CompactSwitchProps = SwitchProps & {
  label?: React.ReactNode
  labelPlacement?: 'end' | 'start'
  tooltip?: string
  tooltipOpen?: boolean
  tooltipProps?: Record<string, any>
  disabled?: boolean
  'data-event-category'?: string
  'data-event-action'?: string
  'data-event-label'?: string
}

const CompactSwitch: React.FC<CompactSwitchProps> = ({
  label,
  tooltip,
  tooltipOpen,
  tooltipProps,
  disabled = false,
  ...props
}) => {
  const containerClass = 'hover-bg-light-bluish-grey ph4 br2 flex items-center justify-center w-100 h2 ma0'
  const labelControl = label !== undefined && label !== null && label !== false
    ? (
      <FormControlLabel
        className={containerClass}
        control={<StyledSwitch {...props} />}
        label={label}
        labelPlacement='start'
        classes={{ label: 'mr3 f6 flex items-center' }}
        disabled={disabled}
        data-event-label
        data-event-category
        data-event-action
      />
      )
    : <StyledSwitch {...props} disabled={disabled} />

  if (tooltip !== undefined && tooltip !== '') {
    return (
      <TealToolTip title={tooltip} open={tooltipOpen} arrow={false} bgColor='dark' textColor='white' {...(tooltipProps ?? {})}>
        {labelControl}
      </TealToolTip>
    )
  }
  return labelControl
}

export default CompactSwitch
